import { render, staticRenderFns } from "./SoftphoneWidget.vue?vue&type=template&id=e47b3792&scoped=true"
import script from "./SoftphoneWidget.vue?vue&type=script&lang=js"
export * from "./SoftphoneWidget.vue?vue&type=script&lang=js"
import style0 from "./SoftphoneWidget.vue?vue&type=style&index=0&id=e47b3792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47b3792",
  null
  
)

export default component.exports